import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ICONS } from '../../../../_helpers/icons.constants';

@Component({
  selector: 'ds-dashboard-action-btn',
  templateUrl: './ds-dashboard-action-btn.component.html',
  standalone: true
})
export class DsDashboardActionBtnComponent {
  @Input() id: string = '';
  /** The label for the action item (e.g. 'Items for Approval') */
  @Input() actionItem: string = '';
  /** The counter value to display */
  @Input() counter: number | string = 0;
  /** Optional icon path (defaults to chevron-right) */
  @Input() iconSrc: string = ICONS.CHEVRON_RIGHT;
  /** Emits when the button is clicked */
  @Output() actionClick = new EventEmitter<void>();

  onClick() {
    this.actionClick.emit();
  }
}

